import React from 'react'
import { Link } from 'react-router-dom'
import time1 from '../assets/time1.webp'
import map from '../assets/map.webp'

export default function Sidebar({ showSidebar, setShowSideBar }) {
  console.log(setShowSideBar)
  return (
    <div className='w-3/4 h-screen text-blue-900 bg-white z-40 fixed flex flex-col  text-2xl p-2' >


      <Link to='/' className='m-2 mt-10 border-b-2 ' onClick={() => setShowSideBar(false)} >Home</Link>
      <Link to='/services' className='m-2 border-b-2 ' onClick={() => setShowSideBar(false)} >Services</Link>
      <Link to='/dentist' className='m-2 border-b-2 ' onClick={() => setShowSideBar(false)}  >Dentist</Link>
      <Link to='/about' className='m-2 border-b-2 ' onClick={() => setShowSideBar(false)} >About</Link>
      <Link to='/blog' className='m-2 border-b-2 ' onClick={() => setShowSideBar(false)} >Blog</Link>
      <Link to='/contact' className='m-2 border-b-2 ' onClick={() => setShowSideBar(false)} >Contact</Link>

      <div className='text-blue-800 text-lg  ' >
        <img src={time1} alt="logo" className='inline-block mb-6' />
        <div className=' pl-5 pt-6 inline-block'>8 am to 6 pm (Mon - Fri) <br /> 10 am to 8 pm (Sat - Sun)</div>
      </div>
      <div className='text-blue-800 text-lg' >
        <img src={map} alt="map" className='inline-block mb-6' />
        <div className=' pl-5 pt-6 inline-block'>258C, Saintpatrick,<br /> Main Street, New York</div>
      </div>

    </div>

  )
}
